<template>
  <div class="workorderHistoryWireUseInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      線材使用資訊
    </li>
    <b-table
      :items="workorderHistoryWireUseInformationItem"
      :fields="workorderHistoryWireUseInformationFields"
      class="
        text-center
        workorderHistoryWireUseInformation-table-detail
        workorderHistoryWireUseInformation-table-detail-last
      "
    >
      <template v-slot:cell(index)="data">{{
        data.index + 1 != workorderHistoryWireUseInformationItem.length
          ? data.index + 1
          : ""
      }}</template>
      <template #cell(consumption)="data" style="">
        {{ data.value.toLocaleString("en-US") }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "workorderHistoryWireUseInformation",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workorderHistoryWireUseInformationFields:
        "workorderHistoryWireUseInformation/get_workorderHistoryWireUseInformationFields",
      workorderHistoryWireUseInformationItem:
        "workorderHistoryWireUseInformation/get_workorderHistoryWireUseInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.workorderHistoryWireUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.workorderHistoryWireUseInformation-table-detail th,
.workorderHistoryWireUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}
.workorderHistoryWireUseInformation-table-detail th:first-child,
.workorderHistoryWireUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.workorderHistoryWireUseInformation-table-detail {
  margin-bottom: 0px;
}
.workorderHistoryWireUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(1) {
  background-color: transparent;
  border-color: transparent !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(2) {
  background-color: transparent;
  border-color: transparent !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(3) {
  background-color: transparent;
  border-color: transparent !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(4) {
  background-color: transparent;
  border-top: 1px transparent solid !important;
  border-left: 1px transparent solid !important;
  border-bottom: 1px transparent solid !important;
  border-right: 2px #c10000 solid !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(5) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
}
.workorderHistoryWireUseInformation-table-detail-last
  tr:last-child
  td:nth-child(6) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
  border-right: 2px #c10000 solid !important;
}
// .workorderHistoryWireUseInformation-table-detail-last
//   tr:last-child
//   td:nth-child(7) {
//   border-bottom: 2px #c10000 solid !important;
//   border-top: 2px #c10000 solid !important;
//   border-right: 2px #c10000 solid !important;
// }
.workorderHistoryWireUseInformation-table-detail tr td {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/workorderHistoryWireUseInformation.vue